import { Resource } from "src/app/global/domain/resource.model";
import { Posto } from "./posto.model";

export class ArquivoImportacaoFinalizado extends Resource {
    nomeArquivoImportacaoFinalizado: string;
    posto: Posto;
    dataCadastro: Date;
    dataInicial: Date;
    dataFinal: Date;
}